import React from "react";
import DashBoardPanel from "./DashBoardPanel";
import Information from "../../common/alerts/Information";

export default function UtilizationPanel(props) {
  
  // Add safety checks for missing data
  const data = props.data || {};
  const isLoaded = props.isLoaded;

  return (
     !props.isLoaded ? 
      <DashBoardPanel title="Current Quarter As Of Last Time Card"><div>Loading data...</div></DashBoardPanel> :
      <>   
      <DashBoardPanel title="Current Quarter As Of Last Time Card">
      <table className="table">
        <tbody>
          <tr>
            <td>Potential Rev Share Hours</td>
            <td>{data.potentialRevShareHours || 0}</td>
          </tr>
          <tr>
            <td>Current Utilization Percentage</td>
            {isLoaded ? displayedData("utilization", data) : <td></td>}
          </tr>
        </tbody>
      </table>
      <Information title="Notes">
        <div style={{ marginBottom: "8px" }}>All hours are as of last timecard.</div>
        <div style={{ marginBottom: "8px" }}>
          Qualified Non-Billable includes Holiday, PTO, Jury Duty, Comp Time, Unpaid Personal Leave, Volunteer Time (4
          hrs max), Funeral Leave, 10 Yr PTO, COVID-Paid leave and President's Club Trip.
        </div>
      </Information> 
    </DashBoardPanel>
    <DashBoardPanel title="Utilization Details">
      <table className="table">
        <tbody>
          <tr>
            <td>Current Utilization Percentage</td>
            {isLoaded ? displayedData("utilization", data) : <td></td>}
          </tr>
          <tr>
              <td>Billable Hours Reported</td>
              <td>{data.billableTime || 0}</td>
          </tr>
          <tr>
            <td>Non Qualified Billable Hours</td>
            <td>{data.nonQualifiedBillableHours || 0}</td>
          </tr>
          <tr>
            <td>Required Hours</td>
            <td>{data.requiredTime || 0}</td>
          </tr>       
        </tbody>
      </table>
    </DashBoardPanel>
    <DashBoardPanel title="RevShare Details">
        <table className="table">
          <tbody>
            <tr>
              <td>Possible Billable Hours</td>
              <td>{data.possibleHours || 0}</td>
            </tr>
            <tr>
              <td>Non-Billable Exempt</td>
              <td>{data.pto || 0}</td>
            </tr>
            <tr>
              <td>Billable Hours Reported</td>
              <td>{data.billableTime || 0}</td>
            </tr>
            <tr>
              <td>Non Qualified Billable Hours</td>
              <td>{data.nonQualifiedBillableHours || 0}</td>
            </tr>
            <tr>
              <td>Required Hours</td>
              <td>{data.requiredTime || 0}</td>
            </tr>            
            {/*<tr>
              <td>Total Hours Reported</td>
              <td>{data.reportedTime}</td>
            </tr>*/}            
          </tbody>
        </table>
      </DashBoardPanel>
    </>

  );
}

function displayedData(field, data) {
  // Add safety check for data
  if (!data || typeof data.utilization === 'undefined') {
    return <td>-</td>;
  }
  
  const utilizationPercentage = (data.utilization * 100).toFixed(2) + "%";
  
  switch (field) {
    case "utilization": {
      if (data.utilization > 0.85) return <td className="table-success">{utilizationPercentage}</td>;
      else if (data.utilization >= 0.8) return <td className="table-warning">{utilizationPercentage}</td>;
      else return <td className="table-danger">{utilizationPercentage}</td>;
    }
    case "billedhours": {
      if (data.billableTime >= data.possibleHours) return <td className="table-success">{data.billableTime}</td>;
      else if (data.billableTime > data.possibleHours * 0.8)
        return <td className="table-warning">{data.billableTime}</td>;
      else return <td className="table-danger">{data.billableTime}</td>;
    }
    default:
      return <td>An error has occured with this data.</td>;
  }
}